import React, {useState } from "react";

import { Container, InputText, ImgLupa, SelectEspcialidade } from "./styles";

import {Cadastro, Especialidades} from "../../../../data/interfaces";

interface OwnProps {
  cadastros : Cadastro[];
  cadastrosTmp: Cadastro[];
  onChange: Function;
}
type Props = OwnProps;

export default function Busca({cadastros, cadastrosTmp, onChange}:Props) {
  const [especialidadeEscolhida, setEspecialidadeEscolhida] = useState<string>("Todos")
  const [chave, setChave] = useState<string>("");



  function handleBuscar() {
    const busca:Cadastro[] = cadastrosTmp.filter( ({especialidade, nome}) =>  especialidade === especialidadeEscolhida && nome.toUpperCase().includes(chave.toUpperCase()) )
    if(busca.length > 0 ){
      onChange(busca);
    }else{
      onChange(cadastrosTmp);
    }
    setChave("");
  }

  return (
    <Container>
      <InputText type="text" value={chave} onChange={(value: React.ChangeEvent<HTMLInputElement>)=>setChave(value.target.value)} placeholder="Busca ..." />
      <SelectEspcialidade value={especialidadeEscolhida} onChange={(
                ev: React.ChangeEvent<HTMLSelectElement>,
            ): void => setEspecialidadeEscolhida(ev.target.value)} id="selectEspecialidades">
        <option value="Todos">Todos</option>
        <option value={Especialidades.ALIMENTACAO_NATURAL}>{Especialidades.ALIMENTACAO_NATURAL}</option>
        <option value={Especialidades.LANCHONETES}>{Especialidades.LANCHONETES}</option>
        <option value={Especialidades.RESTAURANTES}>{Especialidades.RESTAURANTES}</option>
        <option value={Especialidades.SUCOS}>{Especialidades.SUCOS}</option>
        <option value={Especialidades.SUPLEMENTOS}>{Especialidades.SUPLEMENTOS}</option>
      </SelectEspcialidade>
      <ImgLupa onClick={()=>{handleBuscar()}} />
    </Container>
  );
}
